<template>
  <div class="product-title">
    <span>{{label}}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    type: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="less" scoped>
  .product-title{
    font-size: 1.563vw;
    line-height: 5.208vw;
    padding: 1.042vw 0 0;
    font-weight: 600;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/productTitle.vue